// Theme configuration for styled-components
export const theme = {
  colors: {
    bg: '#2A2A32',
    card: '#111522',
    card2: '#0d1220',
    text: '#e5e7eb',
    muted: '#94a3b8',
    border: '#1f2937',
    accent: '#00f7d2',
    accent2: '#5ce9ff',
    white: '#ffffff',
    success: '#34d399',
    error: '#fb7185',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    '2xl': '1.75rem',
    '3xl': '2rem',
    '4xl': '4rem',
  },
  borderRadius: {
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    full: '999px',
  },
  breakpoints: {
    sm: '640px',
    md: '860px',
    lg: '960px',
    xl: '1024px',
  },
  typography: {
    h1: {
      fontWeight: 900,
      fontSize: 'clamp(1.8rem, 3vw + 1rem, 3.2rem)',
      lineHeight: 1.05,
    },
    hxl: {
      fontWeight: 900,
      fontSize: 'clamp(2.2rem, 4vw + 1rem, 4rem)',
      lineHeight: 1,
    },
    h3: {
      fontSize: 'clamp(1.1rem, 1.3vw + 0.6rem, 1.25rem)',
      fontWeight: 700,
    },
  },
};

export const gradientTitle = {
  background: 'linear-gradient(90deg, #00f7d2, #5ce9ff, #fff)',
  WebkitBackgroundClip: 'text',
  color: 'transparent',
};

